import { Badge } from '@/components/ui/badge';

interface MetadataCountBadgeProps {
  entity: Record<string, any>;
  coreFields?: string[];
  customMetadataKey?: string;
}

/**
 * Displays count of metadata fields for an entity
 * Counts core fields that have values + custom metadata fields
 */
export function MetadataCountBadge({
  entity,
  coreFields = [],
  customMetadataKey = 'custom_metadata'
}: MetadataCountBadgeProps) {
  const coreFieldsCount = coreFields.filter(field => {
    const value = entity[field];
    return value !== null && value !== undefined && value !== '';
  }).length;

  const customMetadataCount = entity[customMetadataKey]
    ? Object.keys(entity[customMetadataKey]).length
    : 0;

  const totalCount = coreFieldsCount + customMetadataCount;

  return (
    <Badge variant="outline" className="text-xs whitespace-nowrap">
      {totalCount} field{totalCount !== 1 ? 's' : ''}
    </Badge>
  );
}
